import { useState, useEffect, useCallback } from "react"

import { Guid } from "@/types"
import AssetService from "services/AssetService"
import Asset from "models/Asset"

export default function useAsset(assetId?: Guid | null, onFail?: () => void) {
    const [asset, setAsset] = useState<Asset | null>(null)
    const [isLoading, setIsLoading] = useState(false)

    const fetchAsset = useCallback(async (id: Guid) => {
        setIsLoading(true)
        setAsset(null)

        const fetchedAsset = await AssetService.getAsset(id, {
            withFinancial: true,
            withDisposalEmail: true,
        })

        setAsset(fetchedAsset)
        setIsLoading(false)

        if (!fetchedAsset && typeof onFail === "function") {
            onFail()
        }
    }, [onFail])

    const init = useCallback(() => {
        if (!assetId) {
            setAsset(null)
            setIsLoading(false)
            return
        }
        fetchAsset(assetId)
    }, [assetId, fetchAsset])

    useEffect(() => {
        init()
    }, [init])

    return {
        asset,
        isLoading,
        refetchAsset: init,
    }
}
